import React, { memo, useState } from "react";

type UpdateType<T> = {
  data: T;
  selected: boolean;
};
type ButtonType<T> = {
  text: string;
  onClick: (response: UpdateType<T>) => void;
};
type SelectionButtonType<T> = UpdateType<T> & ButtonType<T>;

const SelectionButton = <T,>({
  data,
  text,
  selected,
  onClick
}: SelectionButtonType<T>) => {
  const [enabled, setEnabled] = useState<boolean>(selected);

  const buttonClasses = [
    "SelectionButton",
    "selection-button",
    "flex items-center justify-center",
    "relative overflow-visible",
    "leading-[1.2]",
    "outline-none transition-all duration-200 ease-in-out",
    enabled ? "selected" : ""
  ]
    .filter(Boolean)
    .join(" ");

  const textClasses = [
    "SelectionButtonText",
    "selection-button-text",
    "font-medium text-sm text-center",
    "w-full whitespace-nowrap overflow-hidden text-ellipsis"
  ].join(" ");

  return (
    <button
      onClick={() => {
        const updatedState = !enabled;
        setEnabled(updatedState);
        onClick({ data, selected: updatedState });
      }}
      className={buttonClasses}
    >
      <span className={textClasses}>{text}</span>
    </button>
  );
};

export default memo(SelectionButton) as typeof SelectionButton;
